import { render } from "./CarbonAd.vue?vue&type=template&id=72788fb0"
import script from "./CarbonAd.vue?vue&type=script&lang=js"
export * from "./CarbonAd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/ads/CarbonAd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72788fb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72788fb0', __exports__)) {
    api.reload('72788fb0', __exports__)
  }
  
  module.hot.accept("./CarbonAd.vue?vue&type=template&id=72788fb0", () => {
    api.rerender('72788fb0', render)
  })

}


export default __exports__